<template>
    <div class="content-wrapper">
        <app-page-top-section :title="$t('pollResponses.title')" icon="briefcase">
            <app-default-button
                v-if="$can('create_poll_response')"
                :title="$addLabel('pollResponse')"
                @click="openPollResponseModal()"
            />
        </app-page-top-section>

        <app-table
            id="poll-response-table"
            :options="options"
            @action="triggerActions"
        />

        <app-poll-responses-modal
            v-if="isPollResponseModalActive"
            v-model="isPollResponseModalActive"
            :selected-url="selectedUrl"
        />

        <app-confirmation-modal
            v-if="confirmationModalActive"
            icon="trash-2"
            modal-id="app-confirmation-modal"
            @confirmed="confirmed('poll-response-table')"
            @cancelled="cancelled"
        />


    </div>
</template>

<script>
import pollResponseMixin from "../../../Mixins/Pms/PollResponseMixin";
import {urlGenerator} from "../../../../../common/Helper/AxiosHelper";

export default {
    name: "pollResponses",
    mixins: [pollResponseMixin],
    data() {
        return {
            pollResponse: '',
            pollResponseId: '',
            pollResponses: [],
            selectedUrl: '',
            modalClass: '',
            promptIcon: '',
            promptSubtitle: '',
            isPollResponseModalActive: false,
            confirmationModalActive: false,
        }
    },
    watch: {
        isPollResponseModalActive: function (value) {
            if (!value) {
                this.selectedUrl = '';
            }
        }
    },
    methods: {
        openPollResponseModal() {
            this.selectedUrl = '';
            this.isPollResponseModalActive = true;
        },
        triggerActions(row, action, active) {
            this.pollResponseId = row.id;
            this.promptIcon = action.icon;
            this.modalClass = action.modalClass;
            this.promptSubtitle = action.promptSubtitle;

            if (action.name === 'edit') {
                this.selectedUrl = `${action.url}/${row.id}`;
                this.isPollResponseModalActive = true;
            }
            if (action.name === 'view_details') {
                this.selectedUrl = window.location = urlGenerator(`${action.url}/${row.id}`);
            }
            else {
                this.getAction(row, action, active)
            }
        },
        cancelled() {
            this.confirmationModalActive = false;
        },
    }
}
</script>
